import style from "./contact.module.scss"
import Formulario from "./Formulario/Formulario";
// import Redes from "./Redes";

function Contact({ translation }) {

    return (
        <div className={style.container}>
            <div className={style.container__form} id="contact">
                <h3 data-aos="fade-right">{translation("navbar.contact")}</h3>
                <p data-aos="fade">{translation("contact.text")}</p>
                <Formulario translation={translation} />
            </div>
            {/* <Redes /> */}
        </div>
    );
}

export default Contact;